export const linkProjection = `
  _key,
  _type,
  i18nLang,
  parentLink->{
    parentLink->{
      slug {
        current
      }
    },
    slug {
      current
    }
  },
  slug {
    current
  },
  title
`.trim();
